import { render, staticRenderFns } from "./ArtistLog.vue?vue&type=template&id=069713aa&scoped=true"
import script from "./ArtistLog.vue?vue&type=script&lang=js"
export * from "./ArtistLog.vue?vue&type=script&lang=js"
import style0 from "./ArtistLog.vue?vue&type=style&index=0&id=069713aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069713aa",
  null
  
)

export default component.exports